import { PaginationData } from 'shared/types';
import request from './requester/renouvellement.request';
import { Renouvellement } from '../models';
import { RequestRotationEnlevementPayload } from '../types';

const renouvellementService = {
  getRenouvellements: (params: object) => request.get<PaginationData<Renouvellement>>('/expeditions', { params }),
  requestRotationEnlevement: (expeditionId: string, data: RequestRotationEnlevementPayload) =>
    request.post(`/${expeditionId}/request-rotation-enlevement`, data),
};

export default renouvellementService;
